import React, { useEffect, useState } from "react";
import SupplierDetail from "../../../../../entities/DashboardPage/AccountingModule/Supplier/SupplierDetails";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";

const SupplierDetailPage = () => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState();
  const [page, setPage] = useState(1);
  const [purchase, setPurchase] = useState();
  const location = useLocation();
  const { showAlert } = useAlert()
  const { item, supplierList, purchaseList } = location.state || {}
  const [oneSupplierDetails, setOneSupplierDetails] = useState([])

  useEffect(() => {
    getBills();
    if (item?._id) {
      getsupplierPurchase(item?._id)
      getOneSupplierDetails(item?._id)
    }
  }, [item])

  const getBills = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getBill(item?._id);
      if (result?.success) {
        setData(result?.data?.bills);
        setCount(result?.data?.total)
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteBill(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getBills();
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleSearch = (text, sort) => {
    text ? getBills(text) : sort ? getBills("", sort) : null
  }

  const getsupplierPurchase = async (supplierName) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSuppliersPurchase(supplierName);
      if (result?.success) {
        setPurchase(result?.data)
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const deletePurchase = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deletePurchase(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        const supplierId = item?._id || supplierList[0]?._id
        getsupplierPurchase(supplierId);
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getOneSupplierDetails = async (id) => {
    try {
      const result = await AuthService.handleGetSupplier(id);
      if (result?.success === true) {
        setOneSupplierDetails(result?.data)
      }
    } catch (error) {
      showAlert(error, "error");
    }
  }

  return (
    <SupplierDetail
      count={count}
      purchase={purchase}
      deletePurchase={deletePurchase}
      purchaseList={purchaseList}
      supplierList={supplierList}
      item={item}
      page={page}
      setPage={setPage}
      data={data}
      handleDelete={handleDelete}
      handleSearch={handleSearch}
      oneSupplierDetails={oneSupplierDetails}
    />)

}

export default SupplierDetailPage;
